export default "__VITE_ASSET__aa50dc46__"